module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NTAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNDUwIDMwMCI+PHBhdGggZmlsbD0iI0ZGQ0UwMCIgZD0iTTAgMGg0NTB2MzAwSDB6Ii8+PHBhdGggZmlsbD0iIzI4OTcyOCIgZD0iTTAgMGg0NTB2MjI1SDB6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMGg0NTB2MTUwSDB6Ii8+PHBhdGggZmlsbD0iIzAwMzA4MiIgZD0iTTAgMGg0NTB2NzVIMHoiLz48cGF0aCBmaWxsPSIjRDIxMDM0IiBkPSJNMTg3LjUgMGg3NXYzMDBoLTc1eiIvPjxwYXRoIGZpbGw9IiNGRkNFMDAiIGQ9Ik03NS4wMjggNy4wMDRMOTQuOSA2Ny45OTYgNDIuOTAyIDMwLjMzM2g2NC4xOTdMNTUuMSA2Ny45OTYgNzUuMDI4IDcuMDA0eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/caf.svg
// module id = MvE2
// module chunks = 0